.bb{justify-content:flex-end;}